<template>
    <div v-if="hasSelecteableSites"
         class="question">
        <h2 class="whitespace-pre-line">{{ $t('Where are you conducting this inspection?') }}</h2>

        <div
            v-if="needsSiteSelected"
            class="w-full form-select mb-3"
            :class="{'empty': !inspection.site}"
            @click="showDropdown">
            <template v-if="inspection.site">
                {{ inspection.sites[inspection.site] }}
            </template>
            <template v-else>
                {{ $t('Select from dropdown') }}
            </template>

        </div>
        <template v-else-if="hasSiteAlreadySet">
            {{ $t(inspection.sites[inspection.site]) }}
        </template>

        <portal to="modals">
            <transition name="fade">
                <DropdownModal
                    v-if="dropdownVisible"
                    :responses="sites"
                    :response="inspection.site ? [inspection.site] : []"
                    :multiple="false"
                    @save="siteSelected"
                    @close="closeDropdown"
                />
            </transition>
        </portal>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import _ from 'lodash';
    import DropdownModal from '@/views/ConductInspection/Modals/DropdownModal.vue';

    export default {
        components: { DropdownModal },
        data: () => ({
            needsSiteSelected: false,
            hasSiteAlreadySet: true,
            hasSelecteableSites: false,
            dropdownVisible: false,
        }),
        computed: {
            inspection() {
                return this.$store.getters['conduct/inspection'];
            },

            sites() {
                // convert sites object to label/value objects
                // so select-control can display them
                return _.map(
                    this.inspection.sites,
                    (value, key) => ({
                        uuid: parseInt(key, 10),
                        title: value,
                    }),
                );
            },

        },
        methods: {
            ...mapActions({
                siteChanged: 'conduct/siteChanged',
            }),

            siteSelected([siteId]) {
                this.siteChanged(siteId);
                this.dropdownVisible = false;
            },

            showDropdown() {
                this.dropdownVisible = true;
            },

            closeDropdown() {
                this.dropdownVisible = false;
            },

            /* saveDropdown(response) {
                this.$store.commit('conduct/changeResponse', {
                    item: this.item.uuid,
                    response,
                    responded: (response.length > 0),
                });
                this.dropdownVisible = false;
            }, */
        },
        created() {
            this.hasSiteAlreadySet = !!this.inspection.site;
            this.hasSelecteableSites = this.inspection.sites && Object.values(this.inspection.sites).length > 0;
            this.needsSiteSelected = this.hasSelecteableSites;
        },
    };
</script>
